import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['construction'], // 为了获取基础路由
    };
};
export const constructionToPathNameMap = {
    // 工作联系单
    construction2300: ({ businessKey }) => commonFunc(`/contact/work/${businessKey}/detail`),
    // 监理进场
    construction1000: ({ businessKey }) => commonFunc(`/work/enter/${businessKey}/detail`),
    // 施工组织设计
    construction1200: ({ businessKey }) => commonFunc(`/design/orgDesign/${businessKey}/detail`),
    // 开工报审
    construction1300: ({ businessKey }) => commonFunc(`/work/report/${businessKey}/detail`),
    // 开工令
    construction1400: ({ businessKey }) => commonFunc(`/work/commence/${businessKey}/detail`),
    // 项目经理报备
    construction1500: ({ businessKey }) => commonFunc(`/person/manager/${businessKey}/detail`),
    // 项目管理机构报备
    construction1600: ({ businessKey }) => commonFunc(`/qualification/organization/${businessKey}/detail`),
    // 分包单位资格报审
    construction1700: ({ businessKey }) => commonFunc(`/qualification/subcontractor/${businessKey}/detail`),
    // 施工作业人员报审
    construction1800: ({ businessKey }) => commonFunc(`/person/worker/${businessKey}/detail`),
    // 特殊工种报审
    construction1900: ({ businessKey }) => commonFunc(`/person/special/${businessKey}/detail`),
    // 专项施工方案
    construction2000: ({ businessKey }) => commonFunc(`/design/specialPlan/${businessKey}/detail`),
    // 危大工程专项施工方案
    construction2100: ({ businessKey }) => commonFunc(`/design/dangerPlan/${businessKey}/detail`),
    // // 危大工程验收
    // construction2200: ({ businessKey }: any) =>
    //   commonFunc(`/dangerAccept/detail?id=${businessKey}`),
    // 工程暂停令
    construction2400: ({ businessKey }) => commonFunc(`/work/suspension/${businessKey}/detail`),
    // 复工报审
    construction2500: ({ businessKey }) => commonFunc(`/work/resumptionReport/${businessKey}/detail`),
    // 复工令
    construction2600: ({ businessKey }) => commonFunc(`/work/resumption/${businessKey}/detail`),
    // 监理报告
    construction2700: ({ businessKey }) => commonFunc(`/supervisor/report/${businessKey}/detail`),
    // // 项目总结
    // construction2800: ({ businessKey }: any) =>
    //   commonFunc(`/summary/detail?id=${businessKey}`),
    // 建筑机器人应用项目
    construction3000: ({ businessKey }) => commonFunc(`/danger/technology/${businessKey}/detail`),
};
